import React from 'react';
import { ToastContainer } from '../pages/trips/components/trip-builder/Toast';

/**
 * Global toast provider component to make toasts accessible throughout the app
 * It should be included at the app root level
 */
const GlobalToastProvider = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer />
    </>
  );
};

export default GlobalToastProvider;
